import { useGlobalState } from "@techsharegov/react-ui";
import { Footer } from "./Footer";
import "./Layout.scss";
import React, { Fragment } from "react";

export const Layout: React.FC = ({ children }) => {
  return (
    <Fragment>
      <div id="toast-container"></div>
      <div className="main">
        <header className="main__header">
          <Header />
        </header>
        <main className={"main__content"}>{children}</main>
        <footer className="main__footer">
          <Footer />
        </footer>
      </div>
    </Fragment>
  );
};

export const Header = () => {
  const { environmentName } = useGlobalState();

  return (
    <div className="header__content flex-vertical-center full-size flex-normal">
      <h4 className="mr-twenty font-secondary-bold">
        Agenda Management Public Access Portal
        <span className="ml-2 color-success font-secondary">
          {environmentName}
        </span>
      </h4>
    </div>
  );
};
